import {
  locationSchema,
  LocationSchema,
} from '@soniq/schema-connection'
import {
  HttpReadWriteStore,
  ProjectionEntityStore,
} from '@soniq/public-resource'

export class LocationHttpStore extends HttpReadWriteStore<LocationSchema> {
  static new() {
    return new LocationHttpStore(
      'location',
      locationSchema.validateFn
    )
  }
}

export class LocationProjectionStore extends ProjectionEntityStore<LocationSchema> {
  static new() {
    return new LocationProjectionStore(
      'location',
      locationSchema
    )
  }
}
